import React from "react";
import { Box } from "@mui/material";

const ShippingSummaryColorStatus = ({ color }: { color: string }) => {
  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        backgroundColor: color,
        borderRadius: "4px",
      }}
    />
  );
};

export default ShippingSummaryColorStatus;
